"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _luxon = require("luxon");
var _api = require("../helpers/api.js");
var _createAction = require("../helpers/createAction.js");
var _dateTime = require("../helpers/dateTime.js");
var _quizzes = require("../selectors/quizzes.js");
var _constants = require("../constants");
var Quizzes = /*#__PURE__*/_createClass(function Quizzes(api) {
  var _this = this;
  _classCallCheck(this, Quizzes);
  this.quizLoading = function (key, promise) {
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_LOADING,
        payload: {
          key: key,
          promise: promise
        }
      });
    };
  };
  this.quizError = function (error, key) {
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_ERROR,
        payload: {
          error: error,
          key: key
        }
      });
      throw error;
    };
  };
  this.quizActionCreator = function (_ref) {
    var getKey = _ref.getKey,
      actionType = _ref.actionType,
      keyMethod = _ref.keyMethod,
      _ref$restAction = _ref.restAction,
      restAction = _ref$restAction === void 0 ? 'post' : _ref$restAction,
      _ref$finalPath = _ref.finalPath,
      finalPath = _ref$finalPath === void 0 ? '' : _ref$finalPath,
      _ref$includeServerTim = _ref.includeServerTime,
      includeServerTime = _ref$includeServerTim === void 0 ? true : _ref$includeServerTim,
      _ref$quizApiTimeout = _ref.quizApiTimeout,
      quizApiTimeout = _ref$quizApiTimeout === void 0 ? 10000 : _ref$quizApiTimeout;
    var action = function action(quizId, userIdArg) {
      return function (dispatch, getState) {
        var _getState = getState(),
          loading = _getState.loading;
        var key = keyMethod(quizId);

        // Prevent loading if the request is already in progress
        if (loading.has(key)) return loading.get(key);
        var promise = _this.api[restAction]("".concat((0, _api.selectedQuestionBankUrl)(getState(), userIdArg), "/quizzes").concat(quizId ? "/".concat(quizId) : '').concat(finalPath), {}, {
          timeout: quizApiTimeout
        }).then(function (response) {
          dispatch({
            type: actionType,
            payload: _objectSpread(_objectSpread(_objectSpread({
              key: key
            }, !!quizId && {
              quizId: quizId
            }), response), includeServerTime && {
              serverTimeNow: (0, _dateTime.getServerTimeNow)()
            })
          });
          return response;
        }).catch(function (error) {
          // Dispatch the error properly in case of failure
          _this.quizError(error, key)(dispatch);
        });

        // Dispatch loading state while waiting for the promise
        _this.quizLoading(key, promise)(dispatch);
        return promise;
      };
    };
    action.getKey = getKey;
    return action;
  };
  this.getQuizFetchPerformanceKey = function (quizId) {
    return "quiz-fetch-performance/".concat(quizId);
  };
  this.quizFetchPerformance = this.quizActionCreator({
    getKey: this.getQuizFetchPerformanceKey,
    actionType: _constants.QUIZ_FETCHED_PERFORMANCE,
    keyMethod: this.getQuizFetchPerformanceKey,
    restAction: 'get',
    finalPath: '?v2'
  });
  this.getQuizFetchPracticeKey = function () {
    return "quiz-fetch-practice";
  };
  this.quizFetchPractice = this.quizActionCreator({
    getKey: this.getQuizFetchPracticeKey,
    actionType: _constants.QUIZ_FETCHED_PRACTICE,
    keyMethod: this.getQuizFetchPracticeKey,
    restAction: 'get',
    finalPath: '/fetch_practice_exam?v2'
  });
  this.getQuizFetchNewKey = function () {
    return 'quiz-fetch-new';
  };
  this.quizFetchNew = this.quizActionCreator({
    getKey: this.getQuizFetchNewKey,
    actionType: _constants.QUIZ_FETCHED_NEW,
    keyMethod: this.getQuizFetchNewKey,
    restAction: 'get',
    finalPath: '/new?v2',
    includeServerTime: false
  });
  this.getQuizSubmitKey = function (quizId) {
    return "submit/".concat(quizId);
  };
  this.quizSubmit = this.quizActionCreator({
    getKey: this.getQuizSubmitKey,
    actionType: _constants.QUIZ_SUBMITTED,
    keyMethod: this.getQuizSubmitKey,
    restAction: 'patch',
    finalPath: '/submit?v2',
    quizApiTimeout: 20000
  });
  this.getArchiveQuizKey = function (quizId) {
    return "archive/".concat(quizId);
  };
  this.quizArchive = this.quizActionCreator({
    getKey: this.getArchiveQuizKey,
    actionType: _constants.QUIZ_ARCHIVED,
    keyMethod: this.getArchiveQuizKey,
    restAction: 'patch',
    finalPath: '/archive',
    includeServerTime: false
  });
  this.getUnarchiveQuizKey = function (quizId) {
    return "unarchive/".concat(quizId);
  };
  this.quizUnarchive = this.quizActionCreator({
    getKey: this.getUnarchiveQuizKey,
    actionType: _constants.QUIZ_UNARCHIVED,
    keyMethod: this.getUnarchiveQuizKey,
    restAction: 'patch',
    finalPath: '/unarchive',
    includeServerTime: false
  });
  this.getQuizzesUnSetOfflineDeviceUuidKey = function (quizId) {
    return _this.getQuizzesSetOfflineDeviceUuidKey(quizId);
  };
  this.quizzesUnsetOfflineDeviceUuid = this.quizActionCreator({
    getKey: this.getQuizzesSetOfflineDeviceUuidKey,
    actionType: _constants.QUIZZES_UNSET_OFFLINE_DEVICE_UUID,
    keyMethod: this.getQuizzesSetOfflineDeviceUuidKey,
    restAction: 'delete',
    finalPath: '/offline_device_uuid'
  });
  this.getQuestionNextKey = function () {
    return "questions/next";
  };
  this.quizQuestionFetchNext = this.quizActionCreator({
    getKey: this.getQuestionNextKey,
    actionType: _constants.QUIZ_QUESTION_FETCHED_NEXT,
    keyMethod: this.getQuestionNextKey,
    restAction: 'get',
    finalPath: '/questions/next?v2',
    includeServerTime: false
  });
  this.getQuizFetchResponsesKey = function (quizId) {
    return "quizzes/".concat(quizId, "/fetch_quiz_responses");
  };
  this.quizFetchResponses = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(quizId) {
      return _this.getQuizFetchResponsesKey(quizId);
    },
    request: function request(getState, quizId) {
      return _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/fetch_quiz_responses"));
    },
    loadingConstant: _constants.QUIZ_RESPONSES_FETCHING,
    loadedConstant: _constants.QUIZ_RESPONSES_FETCHED,
    errorConstant: _constants.QUIZ_RESPONSES_FETCH_ERROR
  });
  this.quizFetchQuestionsKey = function (quizId) {
    return "quizzes/".concat(quizId, "/questions");
  };
  this.quizFetchQuestions = function (quizId) {
    var excludeResponses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
      var key = _this.quizFetchQuestionsKey(quizId);
      var _getState2 = getState(),
        loading = _getState2.loading,
        quizzes = _getState2.quizzes,
        performanceQuestions = _getState2.performanceQuestions;
      if (loading.has(key)) return loading.get(key);
      var quiz = quizzes.get(quizId);
      if (!quiz) return Promise.reject(new Error('Quiz not found'));
      var pageCount = Math.ceil(quiz.get('question_ids').size / 25);
      var requests = [];
      for (var i = 1; i <= pageCount; i += 1) {
        var request = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/questions?page=").concat(i, "&student_id=").concat(quiz.get('user_id'), "&exclude_responses=").concat(excludeResponses)).then(function (response) {
          var difficultyLevels = response.included.filter(function (r) {
            return r.type === 'question';
          }).map(function (json) {
            return {
              id: parseInt(json.id),
              difficulty: performanceQuestions.getIn([parseInt(json.id), 'difficulty'])
            };
          });
          dispatch({
            type: _constants.QUIZ_FETCHED_QUESTIONS,
            payload: _objectSpread(_objectSpread({}, response), {}, {
              quizId: quizId,
              difficultyLevels: difficultyLevels
            })
          });
          return response;
        });
        requests.push(request);
      }
      var promise = Promise.all(requests).then(function (responses) {
        var flattenedResponse = {
          data: responses.filter(function (resultSet) {
            return !!resultSet;
          }).map(function (response) {
            return response.data;
          }).reduce(function (accumulator, item) {
            return accumulator.concat(item);
          }, []),
          included: responses.filter(function (resultSet) {
            return !!resultSet;
          }).map(function (response) {
            return response.included;
          }).reduce(function (accumulator, item) {
            return accumulator.concat(item);
          }, [])
        };
        dispatch({
          type: _constants.QUIZ_FETCHED_ALL_QUESTIONS,
          payload: {
            key: key,
            quizId: quizId,
            serverTimeNow: (0, _dateTime.getServerTimeNow)()
          }
        });
        return flattenedResponse;
      }).catch(function (error) {
        dispatch({
          type: _constants.QUIZ_FETCH_ALL_QUESTIONS_ERROR,
          payload: {
            error: error,
            key: key,
            quizId: quizId
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.QUIZ_FETCHING_ALL_QUESTIONS,
        payload: {
          key: key,
          promise: promise,
          quizId: quizId,
          questionIds: quiz.get('question_ids')
        }
      });
      return promise;
    };
  };
  this.quizFetchTakeKey = function (quizId) {
    return "quizzes/".concat(quizId, "/take");
  };
  this.quizFetchTake = function (quizId) {
    var studentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var fetchAssociations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return function (dispatch, getState) {
      var key = _this.quizFetchTakeKey(quizId);
      var _getState3 = getState(),
        loading = _getState3.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/take?v2=true").concat(!!studentId && "&student_id=".concat(studentId))).then(function (response) {
        // TODO: Reduce the number of state changes here. Currently this triggers THREE dispatches:
        // QUIZ_FETCHED_TAKE, QUIZ_FETCHING_ALL_QUESTIONS, and SERVER_TIME_FETCHED.
        // ATM QUIZ_FETCHED_TAKE must be dispatched before calling quizFetchQuestions() because
        // quizFetchQuestions() requires data for the quiz which is reduced from QUIZ_FETCHED_TAKE.
        dispatch({
          type: _constants.QUIZ_FETCHED_TAKE,
          payload: _objectSpread(_objectSpread({
            key: key
          }, response), {}, {
            serverTimeNow: (0, _dateTime.getServerTimeNow)()
          })
        });
        if (fetchAssociations) dispatch(_this.quizFetchQuestions(quizId));
        var timeDifference = _luxon.DateTime.fromISO(response.meta.server_time).diffNow().milliseconds;
        (0, _dateTime.setTimeDifference)(timeDifference);
        dispatch({
          type: _constants.SERVER_TIME_FETCHED,
          payload: {
            server_time: response.meta.server_time,
            time_difference: timeDifference
          }
        });
        return response;
      }).catch(function (error) {
        return _this.quizError(error, dispatch, key);
      });
      dispatch({
        type: _constants.QUIZ_FETCHING_TAKE,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.quizUnloadTake = function (quizId) {
    return function (dispatch, getState) {
      var _getState4 = getState(),
        quizzes = _getState4.quizzes;
      if (!quizzes.has(quizId)) return;
      dispatch({
        type: _constants.QUIZ_UNLOAD_TAKE,
        payload: {
          quizId: quizId
        }
      });
    };
  };
  this.ltiQuizFetchTakeKey = function () {
    return "quizzes/lti/take";
  };
  this.ltiQuizFetchTake = function (userId, assignmentId, authID, cutoffTime) {
    var fetchAssociations = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    return function (dispatch, getState) {
      var key = _this.ltiQuizFetchTakeKey();
      var _getState5 = getState(),
        loading = _getState5.loading;
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.get("assignments/lti_quiz?user_id=".concat(userId, "&assignment_id=").concat(assignmentId, "&auth_id=").concat(authID, "&ct=").concat(cutoffTime, "&v2"), {
        baseURL: '/api/lti/v1/'
      }).then(function (response) {
        dispatch({
          type: _constants.QUIZ_FETCHED_TAKE,
          payload: _objectSpread(_objectSpread({
            key: key
          }, response), {}, {
            serverTimeNow: (0, _dateTime.getServerTimeNow)()
          })
        });
        var quizId = parseInt(response.data.id);
        if (fetchAssociations) dispatch(_this.quizFetchQuestions(quizId));
        var timeDifference = _luxon.DateTime.fromISO(response.meta.server_time).diffNow().milliseconds;
        (0, _dateTime.setTimeDifference)(timeDifference);
        dispatch({
          type: _constants.SERVER_TIME_FETCHED,
          payload: {
            server_time: response.meta.server_time,
            time_difference: timeDifference
          }
        });
        return quizId;
      }).catch(function (error) {
        return _this.quizError(error, dispatch, key);
      });
      dispatch({
        type: _constants.QUIZ_FETCHING_TAKE,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getQuizzesFetchKey = function () {
    return 'quizzes-fetch-all';
  };
  this.quizzesFetch = function (estimatedQuizCount) {
    return function (dispatch, getState) {
      var key = _this.getQuizzesFetchKey();
      var _getState6 = getState(),
        loading = _getState6.loading;
      if (loading.has(key)) return loading.get(key);

      // By default we'll assume there's only going to be one page of quizzes
      var estimatedPageCount = Math.ceil((estimatedQuizCount || 1) / 50);

      // We may need to make extra requests to get all the quizzes, but we won't have an accurate
      // count of the total quizzes until we get our first response here.
      // To work around this issue we set up extraRequestsPromise as an externally resolved/rejected Promise.
      var resolveExtraRequests;
      var rejectExtraRequests;
      var extraRequestsPromise = new Promise(function (resolve, reject) {
        resolveExtraRequests = resolve;
        rejectExtraRequests = reject;
      });

      // makeExtraRequestsIfNeeded() will only run fully after the first response.
      // It checks for missed pages and creates a new collection of Promises for them if found.
      // If missed pages are found then extraRequestsPromise gets resolved/rejected after the new Promises.
      // If no missed pages are found then extraRequestsPromise gets resolved immediately.
      var checkedForExtraRequests = false;
      var makeExtraRequestsIfNeeded = function makeExtraRequestsIfNeeded(response) {
        if (checkedForExtraRequests) return response;
        checkedForExtraRequests = true;
        if (response.meta && response.meta.total_pages && response.meta.total_pages > estimatedPageCount) {
          var extraRequests = [];
          for (var i = estimatedPageCount + 1; i <= response.meta.total_pages; i += 1) {
            var request = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes?page=").concat(i, "&v2_timed&v2_tutor&v2=true"));
            extraRequests.push(request);
          }
          Promise.all(extraRequests).then(resolveExtraRequests).catch(rejectExtraRequests);
        } else {
          resolveExtraRequests([]);
        }
        return response;
      };

      // Create our collection of Promises for the pages we think we'll find
      var requests = [];
      for (var i = 1; i <= estimatedPageCount; i += 1) {
        var request = _this.api.get("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes?page=").concat(i, "&v2_timed&v2_tutor&v2=true")).then(makeExtraRequestsIfNeeded);
        requests.push(request);
      }

      // Wait for everything to finish (including any extra requests) before resolving
      var promise = Promise.all([extraRequestsPromise, Promise.all(requests)]).then(function (responseArrays) {
        var responses = responseArrays[0].concat(responseArrays[1]);
        var flattenedResponse = {
          data: responses.filter(function (resultSet) {
            return !!resultSet;
          }).map(function (response) {
            return response.data;
          }).reduce(function (accumulator, item) {
            return accumulator.concat(item);
          }, []),
          included: responses.filter(function (resultSet) {
            return !!resultSet;
          }).map(function (response) {
            return response.included;
          }).reduce(function (accumulator, item) {
            return accumulator.concat(item);
          }, [])
        };
        dispatch({
          type: _constants.QUIZZES_FETCHED,
          payload: _objectSpread({
            key: key
          }, flattenedResponse)
        });
        return flattenedResponse;
      }).catch(function (error) {
        return _this.quizError(error, key)(dispatch);
      });
      _this.quizLoading(key, promise)(dispatch);
      return promise;
    };
  };
  this.quizAddQuestionsToSearch = function (questionIds, searchId) {
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_ADD_SEARCH_QUESTIONS,
        payload: {
          questionIds: questionIds,
          searchId: searchId
        }
      });
    };
  };
  this.setSearchQuizQuestionsFetchedAt = function (searchId) {
    return function (dispatch) {
      return dispatch({
        type: _constants.QUIZ_FETCHED_ALL_QUESTIONS,
        payload: {
          key: "SearchQuestions",
          quizId: searchId,
          serverTimeNow: (0, _dateTime.getServerTimeNow)()
        }
      });
    };
  };
  this.getQuizCreateKey = function () {
    return 'quizzes/create';
  };
  this.getQuizCreatePracticeKey = function () {
    return _this.getQuizCreateKey();
  };
  this.quizzesCreatePractice = function (practiceExamTemplateId) {
    var fetchAssociations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var subject_ids = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return function (dispatch, getState) {
      var key = _this.getQuizCreateKey();
      var _getState7 = getState(),
        loading = _getState7.loading;
      if (loading.has(key)) return loading.get(key);
      var quizParams = {
        practice_exam_template_id: practiceExamTemplateId,
        subject_ids: subject_ids,
        v2: true
      };
      var promise = _this.api.post("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/practice_create"), {
        quiz: quizParams
      }).then(function (response) {
        dispatch({
          type: _constants.QUIZ_CREATED,
          payload: _objectSpread({
            key: key,
            serverTimeNow: (0, _dateTime.getServerTimeNow)()
          }, response)
        });
        if (fetchAssociations) {
          var quizId = parseInt(response.data.id);
          dispatch(_this.quizFetchQuestions(quizId));
        }
        return response;
      }).catch(function (error) {
        return _this.quizError(error, dispatch, key);
      });
      dispatch({
        type: _constants.QUIZ_CREATING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.quizzesCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      return _this.getQuizCreateKey();
    },
    request: function request(getState, quizParams) {
      return _this.api.post("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/custom_create"), {
        quiz: quizParams,
        v2: true
      });
    },
    loadingConstant: _constants.QUIZ_CREATING,
    loadedConstant: _constants.QUIZ_CREATED,
    errorConstant: _constants.QUIZ_ERROR,
    successCallback: function successCallback(dispatch, getState, response) {
      var fetchAssociations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (fetchAssociations) {
        var _response$data;
        var quizId = parseInt((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.id);
        _this.quizFetchQuestions(quizId);
      }
    }
  });
  this.getQuizCreateCatKey = function () {
    return _this.getQuizCreateKey();
  };
  this.quizzesCreateCAT = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      return _this.getQuizCreateCatKey();
    },
    request: function request(getState, subjectId, quizName) {
      var quizParams = {
        type: "Adaptive"
      };
      if (subjectId) {
        quizParams.subject_ids = [subjectId];
      }
      if (quizName && quizName !== "") {
        quizParams.name = quizName;
      }
      return _this.api.post("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes"), {
        quiz: quizParams,
        v2: true
      });
    },
    loadingConstant: _constants.QUIZ_CREATING,
    loadedConstant: _constants.QUIZ_CREATED,
    errorConstant: _constants.QUIZ_ERROR,
    successCallback: function successCallback(dispatch, getState, response) {
      var fetchAssociations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (fetchAssociations) {
        var _response$data2;
        var quizId = parseInt((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.id);
        _this.quizFetchQuestions(quizId);
      }
    }
  });
  this.getQuizQuickCreatekey = function () {
    return _this.getQuizCreateKey();
  };
  this.quizzesQuickCreate = function (_ref2) {
    var _ref2$fetchAssociatio = _ref2.fetchAssociations,
      fetchAssociations = _ref2$fetchAssociatio === void 0 ? true : _ref2$fetchAssociatio,
      _ref2$numberOfQuestio = _ref2.numberOfQuestions,
      numberOfQuestions = _ref2$numberOfQuestio === void 0 ? 10 : _ref2$numberOfQuestio,
      _ref2$isAtRisk = _ref2.isAtRisk,
      isAtRisk = _ref2$isAtRisk === void 0 ? false : _ref2$isAtRisk;
    return function (dispatch, getState) {
      var key = _this.getQuizCreateKey();
      var _getState8 = getState(),
        loading = _getState8.loading;
      if (loading.has(key)) return loading.get(key);
      var quizParams = {
        question_limit: numberOfQuestions,
        at_risk: isAtRisk
      };
      var promise = _this.api.post("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/quick"), {
        quiz: quizParams,
        v2: true
      }).then(function (response) {
        dispatch({
          type: _constants.QUIZ_CREATED,
          payload: _objectSpread({
            key: key,
            serverTimeNow: (0, _dateTime.getServerTimeNow)()
          }, response)
        });
        if (fetchAssociations) {
          var quizId = parseInt(response.data.id);
          dispatch(_this.quizFetchQuestions(quizId));
        }
        return response;
      }).catch(function (error) {
        return _this.quizError(error, key)(dispatch);
      });
      dispatch({
        type: _constants.QUIZ_CREATING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.quizCreateSearch = function (searchId) {
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_CREATE_SEARCH,
        payload: {
          searchId: searchId
        }
      });
    };
  };
  this.quizDeleteSearch = function (searchId) {
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_DELETE_SEARCH,
        payload: {
          searchId: searchId
        }
      });
    };
  };
  this.getQuizSeenKey = function (quizId, questionId) {
    return "quiz/".concat(quizId, "/seen/").concat(questionId);
  };
  this.quizSeenQuestion = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(quizId, questionId) {
      return _this.getQuizSeenKey(quizId, questionId);
    },
    request: function request(getState, quizId, questionId) {
      var quiz = (0, _quizzes.selectQuizWithRelationships)(getState(), quizId);
      if (!quiz) return Promise.reject(new Error('Quiz not loaded'));
      if (quiz.get('currentStatus') !== 'incomplete') return Promise.reject(new Error('Quiz already complete'));
      return _this.api.put("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/questions/").concat(questionId, "/seen"));
    },
    loadingConstant: _constants.QUIZ_LOADING,
    loadedConstant: _constants.QUIZ_SEEN_QUESTION_SYNCED,
    errorConstant: _constants.QUIZ_ERROR
  });
  this.quizSeenQuestionOffline = function (quizId, questionId) {
    return function (dispatch, getState) {
      var _getState9 = getState(),
        quizzes = _getState9.quizzes,
        questions = _getState9.questions;
      var quiz = quizzes.get(quizId);
      var groupId = questions.getIn([questionId, 'group_id']);
      var questionNumber = quiz.get('question_ids').indexOf(questionId) + 1;
      var serverTimeNow = (0, _dateTime.getServerTimeNow)();
      dispatch({
        type: _constants.QUIZ_SEEN_QUESTION_OFFLINE,
        payload: {
          lastSeenAt: serverTimeNow,
          quizId: quizId,
          questionId: questionId,
          groupId: groupId,
          questionNumber: questionNumber,
          serverTimeNow: serverTimeNow
        }
      });
    };
  };
  this.getEndQuizBlockKey = function (quizId) {
    return "quizBlock/".concat(quizId);
  };
  this.quizEndQuizBlock = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      return _this.getEndQuizBlockKey();
    },
    request: function request(getState, quizId, quizBlockNumber) {
      return _this.api.patch("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/next_quiz_block"), {
        quiz_block_number: quizBlockNumber
      });
    },
    loadingConstant: _constants.QUIZ_LOADING,
    loadedConstant: _constants.QUIZ_END_QUIZ_BLOCK_SYNCED,
    errorConstant: _constants.QUIZ_ERROR
  });
  this.quizTick = function (quizId) {
    var seconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return function (dispatch) {
      dispatch({
        type: _constants.QUIZ_TICK,
        payload: {
          quizId: quizId,
          seconds: seconds,
          serverTimeNow: (0, _dateTime.getServerTimeNow)()
        }
      });
    };
  };
  this.getQuizTickSyncKey = function (quizId) {
    return "tick/".concat(quizId);
  };
  this.quizTickSync = function (quizId) {
    return function (dispatch, getState) {
      var key = _this.getQuizTickSyncKey(quizId);
      var _getState10 = getState(),
        quizzes = _getState10.quizzes,
        loading = _getState10.loading;
      if (loading.has(key)) return loading.get(key);
      var quiz = quizzes.get(quizId);
      if (!quiz) return Promise.reject(new Error('Quiz tick error, called tick on quiz no loaded'));
      if (quiz.get('practice_exam_template_id') && !quiz.get('quiz_blocks').size) return Promise.reject(new Error('Quiz tick error, called tick on block quiz with no blocks loaded'));
      var currentBlock;
      var quizSecondsRemaining = 0;
      if (quiz.get('quiz_blocks') && quiz.get('quiz_blocks').size) {
        currentBlock = quiz.get('quiz_blocks').find(function (b) {
          return b.get('position') === quiz.get('last_quiz_block_number');
        });
        if (quiz.get('board_exam_interface') === 'fred') {
          if (currentBlock.get('seconds_remaining') <= 0 && currentBlock.get('position') !== quiz.get('quiz_blocks').size) {
            var blocksToGo = quiz.get('quiz_blocks').filter(function (qb) {
              return qb.get('position') > quiz.get('last_quiz_block_number');
            });
            var eligibleBlocks = blocksToGo.filter(function (qb) {
              return qb.get('seconds_remaining') > 0;
            });
            currentBlock = eligibleBlocks.toList().sortBy(function (qb) {
              return qb.get('position');
            }).first();
          }
        }
        if (currentBlock.get('question_ids').size) {
          if (quiz.get('block_pool_seconds_remaining') !== null) {
            quizSecondsRemaining = quiz.get('block_pool_seconds_remaining');
          } else {
            quizSecondsRemaining = currentBlock.get('seconds_remaining');
          }
        } else if (quiz.get('break_pool_seconds_remaining') !== null) {
          quizSecondsRemaining = quiz.get('break_pool_seconds_remaining');
        } else if (quiz.get('break_pool_seconds_remaining') === null) {
          quizSecondsRemaining = currentBlock.get('seconds_remaining');
        }
      } else {
        quizSecondsRemaining = quiz.get('seconds_remaining');
      }
      var promise = _this.api.patch("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/tick"), {
        seconds_remaining: quizSecondsRemaining,
        quiz_block_id: currentBlock ? currentBlock.get('id') : {}
      }).then(function (response) {
        dispatch({
          type: _constants.QUIZ_TICK_SYNCED,
          payload: _objectSpread({
            key: key
          }, response)
        });
        return response;
      }).catch(function (error) {
        return _this.quizError(error, key)(dispatch);
      });
      _this.quizLoading(key, promise)(dispatch);
      return promise;
    };
  };
  this.getArchiveQuizzesKey = function (questionBankId) {
    return "archive-all/".concat(questionBankId);
  };
  this.quizzesArchive = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(questionBankId) {
      return _this.getArchiveQuizzesKey(questionBankId);
    },
    request: function request(getState, questionBankId) {
      var _getState11 = getState(),
        session = _getState11.session;
      var qbId = questionBankId || session.get('selected_question_bank_id');
      return _this.api.patch("".concat((0, _api.currentUserUrl)(getState()), "/question_banks/").concat(qbId, "/quizzes/archive"));
    },
    loadingConstant: _constants.QUIZ_LOADING,
    loadedConstant: _constants.QUIZZES_ARCHIVED,
    errorConstant: _constants.QUIZ_ERROR
  });
  this.getUnarchiveQuizzesKey = function (questionBankId) {
    return "unarchive-all/".concat(questionBankId);
  };
  this.quizzesUnarchive = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(questionBankId) {
      return _this.getUnarchiveQuizzesKey(questionBankId);
    },
    request: function request(getState, questionBankId) {
      var _getState12 = getState(),
        session = _getState12.session;
      var qbId = questionBankId || session.get('selected_question_bank_id');
      return _this.api.patch("".concat((0, _api.currentUserUrl)(getState()), "/question_banks/").concat(qbId, "/quizzes/unarchive"));
    },
    loadingConstant: _constants.QUIZ_LOADING,
    loadedConstant: _constants.QUIZZES_UNARCHIVED,
    errorConstant: _constants.QUIZ_ERROR
  });
  this.getQuizzesSetOfflineDeviceUuidKey = function (quizId) {
    return "quizzes/set-offline-device-uuid/".concat(quizId);
  };
  this.quizzesSetOfflineDeviceUuid = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(quizId) {
      return _this.getQuizzesSetOfflineDeviceUuidKey(quizId);
    },
    request: function request(getState, quizId, deviceUuid) {
      return _this.api.patch("".concat((0, _api.selectedQuestionBankUrl)(getState()), "/quizzes/").concat(quizId, "/offline_device_uuid/").concat(deviceUuid));
    },
    loadingConstant: _constants.QUIZ_LOADING,
    loadedConstant: _constants.QUIZZES_SET_OFFLINE_DEVICE_UUID,
    errorConstant: _constants.QUIZ_ERROR
  });
  this.quizSetLastSeenBlock = function (quizId, position) {
    return function (dispatch) {
      return dispatch({
        type: _constants.QUIZ_SET_LAST_SEEN_BLOCK,
        payload: {
          position: position,
          quizId: quizId
        }
      });
    };
  };
  this.api = api;
}

// All Create Quiz Actions share the same key
);

var _default = exports.default = Quizzes;